module.exports = __webpack_public_path__ + "img/logo_wordmark_black.636460cb.svg";